import { defineMessages } from "react-intl"

export const listingDescriptionMessages = defineMessages({
	title: {
		defaultMessage: "Listing description",
		id: "vehicleDetails.overview.listingDescription.title",
	},
})
